export enum CatalogFieldTypeEnum {
  SEARCHABLE = 'searchable',
  RANKABLE = 'rankable',
  FACETABLE = 'facetable'
}
